const secure = process.env.REACT_APP_HTTPS || '';
const addr = process.env.REACT_APP_DOMAIN;

export default {
  addr: `http${secure}://${addr}`,
  socket: `ws${secure}://${addr}`,
};
